import React from 'react'

export default function Nodatafound() {
  return (
    <div className='nodatafoundclass'>
      <img src="/img/notavailable.png" alt="not found"/>

     <p>Oops ! Looks  like the data is on vacation, but don't worry, possibilities may arise.</p>
    </div>
  )
}
